module.exports = __webpack_public_path__ + "static/styleguide@2x-aed2aa4db334953c867ef1c697e24142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/styleguide@2x.jpg
// module id = 2659
// module chunks = 134932258599989